import { FormProps } from '@deltek/specification-client/core/Models/formProps'

export interface AddProductForm {
    type: Partial<FormProps>
    firmId: Partial<FormProps>
    firmName: Partial<FormProps>
    categories: {
        value?: string[]
        valid?: boolean
        required?: boolean
    }
    sectionNames: Partial<FormProps>
    sectionNumber: Partial<FormProps>
    sectionTitle: Partial<FormProps>
    productType: Partial<FormProps>
    model: Partial<FormProps>
    productName: Partial<FormProps>
}
export enum RadioType {
    Existing = 'existing',
    New = 'new',
}
